import React from "react";

function ErrorPage(props) {
  return (
    <div style={{ textAlign: "center", marginTop: "50px", fontFamily: "Arial, sans-serif", color: "#333" }}>
      <p style={{ fontSize: "18px", margin: "20px 0" }}>
        The Plan you have requested to view is invalid, or it is no longer accessible to you.
      </p>
      <p style={{ fontSize: "18px", margin: "20px 0" }}>Please contact the Project Manager.</p>
    </div>
  );
}

export default ErrorPage;